// @ts-nocheck
import {
  Button,
  Col,
  DatePicker,
  Divider,
  Form,
  Input,
  InputNumber,
  notification,
  Row,
  Select,
  Spin,
  Typography,
  Upload,
} from 'antd';
import React, { useEffect, useState } from 'react';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { Customer, get, postFormData } from '../../../../api';
import type { UploadFile } from 'antd/es/upload/interface';
import dayjs from 'dayjs';
import { UploadOutlined } from '@ant-design/icons';
import { useUser } from '../../../../hooks';
import {
  Invoice,
  CreateInvoice,
  UpdateInvoice,
} from '../../../../api/models/invoices';
import { OrderCustomer } from '../../../../api/models/orders';
type InvoiceFormProps = {
  type: string;
  id?: number | null;
  add: (v: CreateInvoice) => void;
  update: (v: UpdateInvoice) => void;
};

const HistoricBalanceForm: React.FC<InvoiceFormProps> = (props) => {
  const { type, id, add, update, setModalIsVisible } = props;
  const [form] = Form.useForm();
  const [fileXML, setFileXML] = useState();
  const [filePDF, setFilePDF] = useState();
  const [isLoadingForm, setIsLoadingForm] = useState(true);
  const statusOptions = [
    { label: 'Pagada', value: 1 },
    { label: 'Parcialmente pagada', value: 2 },
    { label: 'No pagada', value: 3 },
  ];
  const documentTypeOptions = [
    { label: 'Factura', value: 0 },
    { label: 'Nota de crédito', value: 1 },
  ];
  const { user } = useUser();
  const { Title, Text } = Typography;

  const { isLoading: isLoadingData, data } = useQuery<Invoice>([type], () =>
    get<Invoice>('/invoices/' + id).then((e) => e.data)
  );
  const { isLoading: isLoadingFiles, data: files } = useQuery<Invoice>(
    ['file'],
    () => get<Invoice>('/invoices/' + id + '/files').then((e) => e.data)
  );
  const { isLoading: isLoadingCustomers, data: orders } = useQuery<
    OrderCustomer[]
  >(['orders'], () => get<OrderCustomer[]>('/orders').then((e) => e.data));
  const { isLoading: isLoadingCurrencies, data: currencies } = useQuery<
    Customer[]
  >(['currencies'], () => get<Customer[]>('/currencies').then((e) => e.data));

  useEffect(() => {
    if (type !== 'add' && id && data) {
      form.setFieldsValue({
        legal_number: data.legal_number,
        balance: data.balance,
        order_id: data.order_id,
        due_date: dayjs(data.due_date, 'YYYY-MM-DD'),
        issue_date: dayjs(data.issue_date, 'YYYY-MM-DD'),
        status_id: data.status_id,
        currency_id: data.currency_id,
        document_type_id: data.document_type_id,
      });
    }
    setIsLoadingForm(false);
  }, [form, data, id, type]);

  useEffect(() => {
    if (type === 'files' && id) {
      if (files && files.length > 0) {
        const pdfFile = files.find((file) => file.extension === 'pdf');
        const xmlFile = files.find((file) => file.extension === 'xml');

        setFilePDF(
          pdfFile
            ? [
                {
                  uid: pdfFile.id.toString(),
                  name: pdfFile.name,
                  status: 'done',
                  url: pdfFile.url,
                },
              ]
            : []
        );

        setFileXML(
          xmlFile
            ? [
                {
                  uid: xmlFile.id.toString(),
                  name: xmlFile.name,
                  status: 'done',
                  url: xmlFile.url,
                },
              ]
            : []
        );
      } else {
        setFilePDF(null);
        setFileXML(null);
      }
      setIsLoadingForm(false);
    }
  }, [files, id, type]);

  const xmlChange = (info) => {
    if (info.fileList.length > 0) {
      setFileXML(info.fileList.map((file) => file.originFileObj || file));
    } else {
      setFileXML([]);
    }
  };

  const pdfChange = (info) => {
    if (info.fileList.length > 0) {
      setFilePDF(info.fileList.map((file) => file.originFileObj || file));
    } else {
      setFilePDF([]);
    }
  };

  const propsXml = {
    fileList: fileXML ? [...fileXML] : [],
    onRemove: () => {
      setFileXML(null);
    },
    beforeUpload: (file) => {
      setFileXML([
        {
          uid: file.uid,
          name: file.name,
          status: 'done',
          originFileObj: file,
        },
      ]);
      return false;
    },
    onChange: xmlChange,
  };

  const propsPdf = {
    fileList: filePDF ? [...filePDF] : [],
    onRemove: () => {
      setFilePDF(null);
    },
    beforeUpload: (file) => {
      setFilePDF([
        {
          uid: file.uid,
          name: file.name,
          status: 'done',
          originFileObj: file,
        },
      ]);
      return false;
    },
    onChange: pdfChange,
  };
  const queryClient = useQueryClient();

  const handleRefresh = () => {
    queryClient.invalidateQueries(`/customers/${id}/invoices`);
  };
  const addInvoiceFunction = async (values) => {
    setIsLoadingForm(true);

    if (type === 'add' && user) {
      let invoiceRequest = {
        legal_number: values.legal_number,
        issue_date: values.issue_date,
        order_id: values.order_id,
        status_id: values.status_id,
        currency_id: values.currency_id,
        document_type_id: values.document_type_id,
        due_date: values.due_date,
        balance: values.balance,
      };
      add(invoiceRequest);
    } else if (type === 'files') {
      if (!filePDF || !fileXML) {
        notification['error']({
          message: 'PDF y XML son requeridos',
        });
        return;
      }
      const body = new FormData();
      if (filePDF && filePDF.length > 0 && filePDF[0]) {
        body.append('pdf', filePDF[0]);
      }
      if (fileXML && fileXML.length > 0 && fileXML[0]) {
        body.append('xml', fileXML[0]);
      }

      try {
        await postFormData(`/invoices/${id}/files`, body, true);
      } catch (error) {
        console.error('Error al subir archivos:', error);
      } finally {
        setModalIsVisible(false);
        handleRefresh();
      }
    } else {
      if (!id) return;
      values['id'] = id;
      update(values);
    }
    setIsLoadingForm(false);
  };
  return (
    <Spin
      spinning={isLoadingData || isLoadingFiles || isLoadingForm}
      tip={<p>Cargando...</p>}
    >
      <Form
        name="invoice"
        layout="vertical"
        form={form}
        onFinish={addInvoiceFunction}
      >
        <Divider />
        <Row style={{ display: 'flex', justifyContent: 'center' }}>
          <Col xs={20}>
            {type !== 'files' && (
              <Row gutter={16}>
                <Col xs={24} md={12}>
                  <Form.Item
                    label="Número Legal:"
                    name="legal_number"
                    rules={[
                      {
                        required: true,
                        message: 'Por favor ingrese un número',
                      },
                    ]}
                  >
                    <Input
                      disabled={type === 'watch'}
                      placeholder="Ingresa información"
                    />
                  </Form.Item>
                </Col>

                <Col xs={24} md={12}>
                  <Form.Item
                    label="Saldo:"
                    name="balance"
                    rules={[
                      {
                        required: true,
                        message: 'Por favor ingrese un número',
                      },
                    ]}
                  >
                    <InputNumber
                      disabled={type === 'watch'}
                      style={{ width: '100%' }}
                      placeholder="Ingresa información"
                      formatter={(value) =>
                        `$ ${
                          value
                            ? value
                                .toString()
                                .replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                            : ''
                        }`
                      }
                      parser={(value) =>
                        value ? value.replace(/\$\s?|(,*)/g, '') : ''
                      }
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12}>
                  <Form.Item
                    label="Fecha de Emisión:"
                    name="issue_date"
                    rules={[
                      {
                        required: true,
                        message: 'Por favor seleccione fecha',
                      },
                    ]}
                  >
                    <DatePicker
                      // disabled={type !== 'add'}
                      disabled={type === 'watch'}
                      picker="date"
                      style={{ width: '100%' }}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12}>
                  <Form.Item
                    label="Fecha de Vencimiento:"
                    name="due_date"
                    rules={[
                      {
                        required: true,
                        message: 'Por favor seleccione fecha',
                      },
                    ]}
                  >
                    <DatePicker
                      // disabled={type !== 'add'}
                      disabled={type === 'watch'}
                      picker="date"
                      style={{ width: '100%' }}
                    />
                  </Form.Item>
                </Col>
                {/* <Col xs={24} md={24}>
                {suppliers && (
                  <Form.Item
                    label="Proveedor:"
                    name="supplier"
                    rules={[
                      {
                        required: true,
                        message: 'Por favor seleccione proveedor',
                      },
                    ]}
                  >
                    <Select
                      placeholder="Selecciona una opción"
                      disabled={type !== 'add'}
                      allowClear
                      showSearch
                      optionFilterProp="children"
                    >
                      {suppliers.map((e: any) => (
                        <Select.Option key={e.id} value={e.id}>
                          {e.company_name}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                )}
              </Col> */}
                {/* <CanShow roles={['Admin', 'Financial']}> */}
                <Col xs={24} md={12}>
                  {orders && (
                    <Form.Item
                      label="No. Orden:"
                      name="order_id"
                      rules={[
                        {
                          required: true,
                          message: 'Por favor seleccione orden',
                        },
                      ]}
                    >
                      <Select
                        placeholder="Selecciona una opción"
                        // disabled={type !== 'add'}
                        disabled={type === 'watch'}
                        allowClear
                        showSearch
                        optionFilterProp="children"
                      >
                        {orders.map((e: any) => (
                          <Select.Option key={e.num_order} value={e.num_order}>
                            {e.num_order}
                          </Select.Option>
                        ))}
                      </Select>
                    </Form.Item>
                  )}
                </Col>
                {/* </CanShow> */}
                <Col xs={24} md={12}>
                  <Form.Item
                    label="Estatus:"
                    name="status_id"
                    rules={[
                      {
                        required: true,
                        message: 'Por favor seleccione estatus',
                      },
                    ]}
                  >
                    <Select
                      placeholder="Selecciona una opción"
                      // disabled={type === 'add'}
                      disabled={type === 'watch'}
                      allowClear
                      showSearch
                      options={statusOptions}
                      optionFilterProp="children"
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12}>
                  {currencies && (
                    <Form.Item
                      label="Moneda:"
                      name="currency_id"
                      rules={[
                        {
                          required: true,
                          message: 'Por favor seleccione moneda',
                        },
                      ]}
                    >
                      <Select
                        placeholder="Selecciona una opción"
                        // disabled={type !== 'add'}
                        disabled={type === 'watch'}
                        allowClear
                        showSearch
                        optionFilterProp="children"
                      >
                        {currencies.map((e: any) => (
                          <Select.Option key={e.id} value={e.id}>
                            {e.description}
                          </Select.Option>
                        ))}
                      </Select>
                    </Form.Item>
                  )}
                </Col>
                <Col xs={24} md={12}>
                  <Form.Item
                    label="Tipo de documento:"
                    name="document_type_id"
                    rules={[
                      {
                        required: true,
                        message: 'Por favor seleccione tipo de documento',
                      },
                    ]}
                  >
                    <Select
                      placeholder="Selecciona una opción"
                      // disabled={type === 'add'}
                      disabled={type === 'watch'}
                      allowClear
                      showSearch
                      options={documentTypeOptions}
                      optionFilterProp="children"
                    />
                  </Form.Item>
                </Col>
              </Row>
            )}
            {type === 'files' && (
              <>
                <Row>
                  <Col xs={24} lg={10}>
                    <Title level={5} type="secondary">
                      Seleccionar archivo XML
                      <Text type="danger">*</Text>
                    </Title>
                  </Col>

                  <Col xs={24} lg={14} className="upload-file-form__container">
                    <Upload
                      {...propsXml}
                      accept={'.xml'}
                      multiple={false}
                      maxCount={1}
                      listType="picture"
                    >
                      <Button
                        className="upload-file-btn"
                        icon={<UploadOutlined />}
                        size="large"
                      >
                        Subir Archivo
                      </Button>
                    </Upload>
                  </Col>
                </Row>
                <Divider />
                <Row>
                  <Col xs={24} lg={10}>
                    <Title level={5} type="secondary">
                      Seleccionar archivo PDF
                      <Text type="danger">*</Text>
                    </Title>
                  </Col>
                  <Col xs={24} lg={14} className="upload-file-form__container">
                    <Upload
                      {...propsPdf}
                      accept={'.pdf'}
                      maxCount={1}
                      listType="picture"
                    >
                      <Button
                        className="upload-file-btn"
                        icon={<UploadOutlined />}
                        size="large"
                        // disabled={fileListXML.length === 1}
                      >
                        Subir Archivo
                      </Button>
                    </Upload>
                  </Col>
                </Row>
              </>
            )}
            <Row justify="end">
              <Form.Item>
                <Button
                  htmlType="submit"
                  className="btn-add"
                  disabled={type === 'watch' || isLoadingData || isLoadingForm}
                >
                  Guardar
                </Button>
              </Form.Item>
            </Row>
          </Col>
        </Row>
      </Form>
    </Spin>
  );
};

export default HistoricBalanceForm;
